// removed by extract-text-webpack-plugin
module.exports = {"container":"XesXVyh1L70E6PZ7VyDfO","infoContainer":"_1GFhOUzSLhsK9u7Wtn9R-6","intersectionContainer":"_XvZy4iu53tSkpUiLoQRh"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Users/UserPage/UserPage.pcss
// module id = 1368
// module chunks = 0